import React, { useContext, useEffect, useState } from 'react'
import './ContactUs.css'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { useHistory } from 'react-router-dom'
import { mapData, handleRedirectInternal } from '../../../Product/common/components'
import PrimaryButton from '../../../Product/components/atoms/PrimaryButton'
import AuthContext from '../../../Product/context/auth/authContext'
import UserContext from '../../../Product/context/user/userContext'
import Layout from '../Layout'
import ProductContext from '../../../Product/context/product/productContext'
import axios from 'axios'

function ContactUs() {
    const authContext = useContext(AuthContext)
    const userContext = useContext(UserContext)
    const { send_contactus, responseStatus } = userContext
    const { user, loadUser } = authContext
    const history = useHistory()
    const contactEmail = global?.storeDetails?.contact_email
    const contactPhone = global?.storeDetails?.phone
    const contactAddress = global?.storeDetails?.address
    const productContext = useContext(ProductContext)
    const { productLocalState } = productContext
    const [wizLocation, setWizLocation] = useState(contactAddress)
    const validationArray = Yup.object({
        name: Yup.string()
            .trim()
            .matches(/^[a-zA-Z ]*$/g, 'Special characters not allowed')
            .max(15, 'Maximum 15 characters')
            .required('Required'),

        from_email: Yup.string().email('Invalid email format').required('Required'),
        phone_number: Yup.string()
            .trim()
            .matches(/^\+/, 'Please enter country code')
            .matches(/^[+]?[-]?[^a-z][0-9]+$/, 'Invalid Number!')
            .min(12, 'Invalid Number!')
            .max(16, 'Maximum 14 characters')
            .required('Required'),
        subject: Yup.string().required('Required'),
        messages: Yup.string().trim().required('Required'),
    })

    const formik = useFormik({
        initialValues: {
            name: '',
            last_name: '',
            from_email: '',
            phone_number: global?.storeConfigration?.default_phone_code?.value
                ? global?.storeConfigration?.default_phone_code?.value
                : '',
            subject: '',
            messages: '',
            is_send_email: 1,
            phone_number_new: '',
        },
        validationSchema: validationArray,
        onSubmit: (values) => {
            send_contactus(values)
        },
    })

    useEffect(() => {
        if (responseStatus) {
            if (responseStatus.from === 'send_contactus') {
                if (responseStatus.status === 'success') {
                    handleRedirectInternal(history, '')
                }
            }
        }
    }, [responseStatus])
    // console.log(process.env.REACT_APP_URL, 'getWizLocations')
    useEffect(() => {
        const getWizLocations = async () => {
            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_URL}get_schedule_locations`,
                    { params: { site_id: global.storeDetails.site_id } },
                )
                const allWizLoc = response.data.data || []
                const parsedLocations = allWizLoc.map((item) => {
                    let parsedLocData = []
                    try {
                        parsedLocData = JSON.parse(item.location)
                    } catch (e) {
                        console.error('Error fetching locations:', item.location)
                    }
                    return {
                        ...item,
                        parsedLocData: parsedLocData,
                    }
                })
                const locResult = parsedLocations?.find((item) => {
                    const loc = item.parsedLocData?.[0]
                    if (!loc) return false
                    const fullAddress =
                        `${loc.business_address1} ${loc.business_address2} ${loc.business_city} ${loc.business_state} ${loc.business_zip}`.toLowerCase()
                    const searchTerm = productLocalState.globalLocation?.toLowerCase()
                    return fullAddress.includes(searchTerm)
                })
                if (locResult?.parsedLocData?.[0]) {
                    const loc = locResult.parsedLocData[0]
                    const fullAddress = `${loc.business_address1} ${loc.business_address2} ${loc.business_city} ${loc.business_state} ${loc.business_zip}`
                    setWizLocation(fullAddress)
                }
                console.log(
                    response?.data,
                    locResult,
                    parsedLocations,
                    allWizLoc,
                    wizLocation,
                    productLocalState.globalLocation,
                    'getWizLocations',
                )
            } catch (error) {
                console.error('Error fetching locations:', error)
            }
        }
        getWizLocations()
    }, [productLocalState.globalLocation])
    useEffect(() => {
        if (global?.storeConfigration?.default_phone_code?.value) {
            var phone_code = global?.storeConfigration?.default_phone_code?.value
            if (
                formik.values.phone_number.length < phone_code.length ||
                !formik.values.phone_number.includes(phone_code)
            ) {
                formik.setFieldValue('phone_number', formik.values.phone_number_new)
            } else {
                formik.setFieldValue('phone_number_new', formik.values.phone_number)
            }
        }
    }, [formik.values.phone_number])

    const contactInfo = [
        {
            label: 'Name',
            name: 'name',
            type: 'text',
            placeholder: 'Enter your first name',
            class: 'col-sm-6 col-12',
            autoFocus: true,
            formik: formik,
        },

        {
            label: 'Email address',
            name: 'from_email',
            type: 'text',
            placeholder: 'Enter your email address',
            class: 'col-sm-6 col-12',
            formik: formik,
        },
        {
            label: 'Phone number',
            name: 'phone_number',
            type: 'text',
            placeholder: 'Enter your phone number',
            class: 'col-sm-6 col-12',
            formik: formik,
        },
        {
            label: 'Subject',
            name: 'subject',
            type: 'text',
            placeholder: 'Enter your subject',
            class: 'col-12',
            formik: formik,
        },
        {
            label: 'Message',
            name: 'messages',
            type: 'textarea',
            placeholder: 'Enter your message',
            class: 'col-12',
            formik: formik,
        },
    ]
    useEffect(() => {
        loadUser()
    }, [])

    useEffect(() => {
        if (user) {
            formik.values.name = user?.first_name + ' ' + user?.last_name || ''
            formik.values.phone_number = user?.phone || ''
            formik.values.from_email = user?.email || ''
            formik.values.subject = 'General Enquiry'
        }
    }, [user])
    const checkThemeClassName = document.body.className == 'liquidationTwo primeBids'
    const wizardProj = document.body.className == 'liquidationTwo wizardTheme'
    return (
        <Layout>
            <div className="contact-main-container">
                <div className="contact-banner">
                    <img src="/assets/images/contact_us.png" alt="" />
                </div>
                <div className="container cu-margin-125">
                    <div className="row d-flex justify-content-center">
                        {checkThemeClassName ? (
                            ''
                        ) : (
                            <div className="col-xs-12 col-md-8 padtop">
                                <div className="contactform">
                                    <div className="cu-head">Contact us</div>
                                    <div className="text-center scontact-us-wrap flex-btnscol">
                                        <form onSubmit={formik.handleSubmit}>
                                            <div className="row">
                                                {Object.values(mapData(contactInfo))}
                                                <div className="col-12">
                                                    <PrimaryButton label="Submit" type="submit" />
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        )}

                        <div
                            className={`"col-xs-12" ${
                                checkThemeClassName ? '' : 'col-md-4'
                            } "padtop"`}
                        >
                            <div className="contactform cfRt">
                                <div className="cu-head">Reach Us</div>
                                {/* {contactAddress && contactAddress != 'null' && ( */}
                                <div className="media">
                                    <div className="media-left">
                                        <span className="material-icons">location_on</span>
                                    </div>
                                    <div className="media-body">
                                        <h5 className="ru-head">Address</h5>
                                        <span className="ru-con">{wizLocation}</span>
                                    </div>
                                </div>
                                {/* )} */}
                                {contactEmail && (
                                    <div className="media">
                                        <div className="media-left">
                                            <span className="material-icons">mail</span>
                                        </div>
                                        <div className="media-body">
                                            <h5 className="ru-head">Email address</h5>
                                            <a href={`mailto:${contactEmail}`} className="ru-con">
                                                {contactEmail}
                                            </a>
                                        </div>
                                    </div>
                                )}
                                {!wizardProj ? (
                                    <>
                                        {' '}
                                        {contactPhone && (
                                            <div className="media">
                                                <div className="media-left">
                                                    <span className="material-icons">call</span>
                                                </div>
                                                <div className="media-body">
                                                    <h5 className="ru-head">Call</h5>
                                                    <a
                                                        href={`tel:${contactPhone}`}
                                                        className="ru-con"
                                                    >
                                                        <span dir="ltr">{contactPhone}</span>
                                                    </a>
                                                </div>
                                            </div>
                                        )}
                                    </>
                                ) : null}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default ContactUs
